import { Helmet } from 'react-helmet';

export type DocumentTitleProps = {
    title?: string;
};

export function DocumentTitle({ title }: DocumentTitleProps) {
    return <Helmet>{title && <title>{title}</title>}</Helmet>;
}
